//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { useSelector } from 'react-redux';

import { ICuralateStore } from '@models/AppState';

export const useBulkActionsSelectedItems = () => {
  return useSelector(
    (state: ICuralateStore) => state.bulkActions.selectedItemsForContentSource,
  );
};
